import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref } from 'vue';

import {
  Heading,
  SingleInput,
  BaseText,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';


export default /*#__PURE__*/_defineComponent({
  __name: 'ObjectiveName',
  setup(__props) {

const updateData = inject('updateData', (key: string, name: string) => ({
  key,
  name
}));

const objectiveName = ref('');

const isDisabled = computed(() => {
  return objectiveName.value.trim() === '';
});

const counter = computed(() => {
  return `${objectiveName.value.length}/30`;
});

function clearName() {
  objectiveName.value = '';
}

function handleUpdateName() {
  if (isDisabled.value) return;

  updateData('objectiveName', objectiveName.value);
}

return { __sfc: true,updateData, objectiveName, isDisabled, counter, clearName, handleUpdateName, Heading, SingleInput, BaseText, ButtonContainer, ButtonPrimary }
}

})